import React, { useMemo } from 'react';
import { Swimlane } from '../../../../../components/Swimlane/Swimlane';
import { Layout } from '../../../../../queries/ats/layout/types';
import { SubscribedProduct } from '../../../../../queries/ats/me/products/types';
import { combineEpisodesIntoSeries } from '../../../../../queries/ats/me/products/utils';
import { Title } from '../../../../../queries/ats/titles/types/title';
import { PatternHandler } from '../../../PatternHandler';
import { getSectionLink, titlesToSectionItems } from '../../../utils';
import { PersonalizedGrid } from './personalized-grid';

const MAX_SWIMLANE_COUNT = 40;

interface PersonalizedSwimlaneProps {
  view: Layout.SectionView;
  items: Layout.SectionItem[];
  titles: Title[];
  products: SubscribedProduct[];
  pageStyle: 'grid' | 'swimlane';
  isFetching?: boolean;
}

export function PersonalizedSwimlane({
  view,
  titles,
  items,
  products,
  pageStyle,
  isFetching,
}: PersonalizedSwimlaneProps) {
  const combinedTitles = useMemo(() => {
    return combineEpisodesIntoSeries(titles, products);
  }, [products, titles]);

  const titleItems = titlesToSectionItems(combinedTitles);
  const link = getSectionLink(items);

  if (pageStyle === 'grid') {
    return <PersonalizedGrid view={view} data={titleItems} />;
  }

  return (
    <Swimlane>
      <Swimlane.Header>
        <Swimlane.Title to={link}>{view.label}</Swimlane.Title>
        <Swimlane.Buttons />
      </Swimlane.Header>
      <Swimlane.Slider>
        {isFetching && <PatternHandler.Skeleton pattern={view.style.pattern} />}
        {[...titleItems.slice(0, MAX_SWIMLANE_COUNT - 1), ...items].map((item, index) => (
          <PatternHandler key={index} pattern={view.style.pattern} item={item} />
        ))}
      </Swimlane.Slider>
    </Swimlane>
  );
}
